"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.haulerColumnFullWidthProps = exports.haulerColumnProps = exports.haulerTypes = void 0;
const constants_1 = require("utils/constants");
exports.haulerTypes = {
    SET_DATA_GRID: 'HAULER TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'HAULER TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'HAULER TYPES ON MUTATION',
    ON_CHANGE_DATAITEM: 'HAULER TYPES ON CHANGE DATAITEM',
    ON_SAVE_DATAITEM: 'HAULER TYPES ON SAVE DATAITEM',
    ON_DELETE: 'HAULER TYPES ON DELETE',
    GET_DETAIL: 'HAULER TYPES ON GET DETAIL',
    ON_FILTER_CHANGE: 'HAULER TYPES ON FILTER CHANGE',
    ON_SORT_CHANGE: 'HAULER TYPES ON SORT CHANGE',
    SET_ERROR: 'HAULER TYPES SET ERROR',
    SET_LOADING: 'HAULER TYPES SET LOADING'
};
exports.haulerColumnProps = [
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: '400px',
        filter: 'text'
    },
    {
        show: true,
        field: 'hauler_no',
        title: 'Hauler NO',
        width: '200px',
        filter: 'text'
    },
    {
        show: true,
        field: 'hauler_spec',
        title: 'Hauler Spec',
        width: '200px',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '140px',
        filter: 'boolean'
    },
];
exports.haulerColumnFullWidthProps = [
    ...exports.haulerColumnProps
];
exports.haulerColumnFullWidthProps[0] = {
    show: true,
    field: 'contractor_name',
    title: 'Contractor',
    width: 'auto',
    filter: 'text'
};
